import { render, staticRenderFns } from "./Wp_mini_guide.vue?vue&type=template&id=22780261&scoped=true&"
import script from "./Wp_mini_guide.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22780261",
  null
  
)

export default component.exports